import React, { useEffect } from 'react';
import '../../styles/App.scss';
import { useGlobalStore } from '../../utils/global-store/vo/Vo-globalStore';
import * as Sentry from "@sentry/react";

//local 
import ReviewPage from '../../components/vo/review-page/ReviewPage';

const VoReviewApp = ({ moduleData,moduleName }) => {
  const [globalVariable, globalVariabledispatch] = useGlobalStore(false);
  globalVariabledispatch('SET_MODULE_DATA', { moduleData: moduleData });

  return (
    <div>
         <ReviewPage></ReviewPage>
    </div>
  );
}

//export default VoReviewApp;
export default Sentry.withProfiler(VoReviewApp);

